/* eslint-disable no-console -- sink console desta fase */
import type { ILoggerProvider } from '../logging/types';
import type { TLogFields, TLogLevel } from '../types';

type TConsoleFn = (message?: unknown, ...optionalParams: unknown[]) => void;

const LEVEL_FN: Record<TLogLevel, TConsoleFn> = {
  debug: (...args) => {
    console.debug(...args);
  },
  info: (...args) => {
    console.info(...args);
  },
  warn: (...args) => {
    console.warn(...args);
  },
  error: (...args) => {
    console.error(...args);
  },
};

export class ConsoleLoggerProvider implements ILoggerProvider {
  log(level: TLogLevel, message: string, fields?: TLogFields): void {
    const fn = LEVEL_FN[level];
    if (fields && Object.keys(fields).length > 0) {
      fn(`[${level}]`, message, fields);
      return;
    }
    fn(`[${level}]`, message);
  }

  async flush(): Promise<void> {}

  async shutdown(): Promise<void> {}
}
